exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/*\n * Repeating the background mostly makes sense in the <body>. Otherwise, people\n * usually want the image and preferably its center (not the top-right corner)\n */\n*:not(body) {\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: cover;\n}\n/*\n * tables borders like they should be\n * applied to * to also works for display: table;\n */\nhtml {border-collapse: collapse}\n* {border-collapse: inherit}\n/*\n * box model like it should be\n *\n * http://www.paulirish.com/2012/box-sizing-border-box-ftw/\n */\nhtml {box-sizing: border-box}\n\n*,\n*:before,\n*:after {\n  box-sizing: inherit;\n}\n/*\n * kill document defaults margin & padding. We all do that all the times, right ?\n */\nhtml,\nbody {\n  margin: 0;\n  padding: 0;\n}\n/*\n * Makes the hidden attribute works even when an element is styled display: flex\n * http://lists.w3.org/Archives/Public/public-whatwg-archive/2014May/0001.html\n */\n[hidden] {display: none !important}\n\nbody {\n  font-family: Microsoft YaHei,helvetica,tahoma,arial,SimSun;\n  line-height: 1.42857143;\n  color: #333;\n  -webkit-touch-callout: none;\n}\n", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/postcss-loader!./example/style.css
 ** module id = 30
 ** module chunks = 0
 **/